import produce from 'immer';

const INITIAL_STATE = {
  messages: [],
  id:'',
  sessionId:'',
  conversationAttendant:false
}

export default function conversation(state = INITIAL_STATE,action){ 
  switch(action.type){
    case '@conversation/ADD_MESSAGE':
      return produce(state, draft => {
        const incomingMessages = Array.isArray(action.payload.messages)
          ? action.payload.messages
          : [action.payload.messages];

        incomingMessages.forEach(newMsg => {
          if (newMsg._id) {
            const exists = draft.messages.some(msg => msg._id === newMsg._id);
            if (!exists) {
              draft.messages.push(newMsg);
            }
          } else {
            draft.messages.push(newMsg);
          }
        });
      });
    case '@conversation/REPLACE_MESSAGES':
      return produce(state, draft => {
        draft.messages = Array.isArray(action.payload.messages) 
          ? action.payload.messages 
          : [action.payload.messages];
      });
    case '@conversation/ADD_SESSION_ID':
      return produce(state, draft => {
        draft.sessionId = action.payload.sessionId
      });
    case '@conversation/ADD_CONVERSATION_ATTENDANT':
      return produce(state, draft => {
        draft.conversationAttendant = action.payload.conversationAttendant
      });
    case '@conversation/CLEAR_CONVERSATION':
      return produce(state, draft => {
        draft.messages = [];
        draft.id = '';
      });
    default:
      return state;
  }
}